<template>
    <div>
        <el-row class="video-tree flex" >

            <el-col :span="treespan"   :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
                <div class="ps-re">
                    <el-select  style="width: 100px"  class="usebutton" v-model="isuse" size="mini"  @change="refreshTree">
                        <el-option v-for="item in isuseList" :key="item.i_id" :label="item.vc_name" :value="item.i_id">
                        </el-option>
                    </el-select>
                    <div class="fitW font14">
                        <el-tree ref="tree" :data="treeData" lazy :key="treeId" :load="loadNode" :props="defaultProps"
                                 node-key="i_id" @node-click="handleNodeClick" :default-expanded-keys="[0]"
                                 class="trees  video-tree height100" accordion :highlight-current='true'
                                 :expand-on-click-node="false" :show-checkbox="false">
                            <div class="custom-tree-node" style="width: 100%"  slot-scope="{ node, data }">
                            <span @contextmenu="showMenuFun($event,node, data)">
    <!--                                <i class="el-icon-folder-opened"></i>-->
<!--                                <template v-if="data.type==1">-->
<!--                                        <i class="el-icon-folder-opened" style="padding-right: 5px"></i>-->
<!--                                </template>-->
<!--                                <template v-if="data.type==0">-->
<!--                                    <i v-if="data.isMainType==null||data.isMainType==undefined" class="el-icon-document" style="padding-right: 5px"></i>-->
<!--                                </template>-->
                                    <span>{{ node.label }}</span>
                                <div v-if="showMenuId==data.i_id" class="menu"  style="z-index: 2">
    <!--          @node-contextmenu="showMenuFun"                   :style="{left:`${menuX}px`,top:`${menuY}px`}"-->
                                    <template>
                                        <div  class="info" v-if="(data.i_id||data.i_id==0)&&data.i_level<3"  @click.stop="addFun(data,'add')"><i class="el-icon-folder-add" style="margin-right: 8px; transform: rotate(90deg)"></i>{{addMenu}}</div>
                                        <div  class="info" v-if="data.i_id&&data.i_id!=0" @click.stop="addFun(data,'edit')" ><i class="el-icon-edit" style="padding-right: 8px"></i>{{editMenu}}</div>
                                        <div  class="info" v-if="data.i_id&&data.i_level!=0"  @click.stop="transferFun(data)"><i class="el-icon-sort" style="margin-right: 8px; transform: rotate(90deg)"></i>{{transferMenu}}</div>
                                    </template>
                                </div>
                            </span>
                            </div>
                        </el-tree>

                    </div>
                </div>

            </el-col>
            <el-col :span="rightspan" id="tabelBox" style="height: 100%;min-width: 320px;width: 100%">
<!--                <el-button type="text" :class="[baseerp+'color','nopadding']"   @click="isright=!isright"  :icon="isright?'el-icon-s-fold':'el-icon-s-unfold'"></el-button>-->
                <el-button class="marB10" v-if="chooseNode&&chooseNode.i_level==3"  @click="addFun(chooseNode,'add')" :class="baseerp+'btn'" size="mini">新增</el-button>
                <el-table class="mrt10" ref="table" row-key="wyid"  size="mini" :height="tableHeight+100" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" align="center" type="index" width="50px"></el-table-column>

                    <el-table-column align="center" label="街道" prop="vc_name" show-overflow-tooltip>
<!--                        <template slot-scope="scope">-->
<!--                            <el-input v-if="canEdit" v-model="scope.row.vc_name" size="mini" placeholder="请输入"></el-input>-->
<!--                            <div class="mrA" v-else>{{scope.row.vc_name}}</div>-->
<!--                        </template>-->
                    </el-table-column>
                    <el-table-column label="操作" width="120" align="center">
                        <template slot-scope="scope">
                            <el-button  type="text"  @click="addFun(scope.row,'edit')"  size="mini">编辑</el-button>
                            <el-button  type="text"  @click="transferFun(scope.row)"  size="mini">转移</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <div :class="baseerp+'div'">
            <el-dialog :title="addTitle" width="500px"  :visible.sync="dialogVisible"
                       :close-on-click-modal="false" @close="closeAddFun">
                <add-page :data="addProp" v-if="dialogVisible" @close="closeAddFun"></add-page>
            </el-dialog>
            <el-dialog :title="transferTitle" width="500px"  :visible.sync="dialogTransferVisible"
                       :close-on-click-modal="false" @close="closeTransferFun">
                <transfer-area :data="transferProp" v-if="dialogTransferVisible" @close="closeTransferFun"></transfer-area>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import AddPage from "./AddPage";
    import TransferArea from "./TransferArea";

    export default {
        name: "index",
        components: {AddPage,TransferArea},
        props: {},
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_id'
                },
                isuse:1,
                treeData:[{i_id:0,i_level:1,i_pid:0,label:'全部',children:[],isLeaf:false}],
                treeId:0,
                showMenuId:null,
                isuseList:[{i_id:1,vc_name:'启用'},{i_id:0,vc_name:'未启用'}],
                treespan:4,
                rightspan:20,
                canEdit:false,
                tableData:[],
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                addProp:{},
                transferProp:{},
                addTitle:'',
                transferTitle:'',
                dialogVisible:false,
                dialogTransferVisible:false,
                addMenu:'',
                editMenu:'',
                transferMenu:'',
                chooseNode:null,

            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.$nextTick(() => {
                this.onResize();
            })
            let that=this,box=document.getElementById('tabelBox');
            box.addEventListener('mouseup',function (event) {
                if(event.button===0||event.button==2){
                    // console.log('down------------------')
                    that.showMenuId=null

                }
            })
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3+100;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },

            refreshTree(){
                this.treeId=Math.random();
            },
            showMenuFun(event,node, val){
                // console.log( data,'val')
                event.preventDefault();
                this.showMenuId=val.i_id;
                    if(val.i_id==0&&val.i_level==0) {
                        this.addMenu = '新增国家'
                    }else if(val.i_id&&val.i_level==0){
                        this.addMenu='新增省'
                        this.editMenu='编辑国家'
                        this.transferMenu=''
                    }else if(val.i_id&&val.i_level==1){
                        this.addMenu='新增市'
                        this.editMenu='编辑省'
                        this.transferMenu='转移省'
                    }else if(val.i_id&&val.i_level==2){
                        this.addMenu='新增区'
                        this.editMenu='编辑市'
                        this.transferMenu='转移市'
                    }else if(val.i_id&&val.i_level==3){
                        this.addMenu='新增街道'
                        this.editMenu='编辑区'
                        this.transferMenu='转移区'
                    }

            },
            addFun(val,type){
                let data=JSON.parse(JSON.stringify(val));
                this.dialogVisible=true;
                if(type=='add'){
                    if(val.i_id==0&&val.i_level==0) {
                        this.addTitle = '新增国家'
                    }else if(val.i_id&&val.i_level==0){
                        this.addTitle='新增省'
                    }else if(val.i_id&&val.i_level==1){
                        this.addTitle='新增市'
                    }else if(val.i_id&&val.i_level==2){
                        this.addTitle='新增区'
                    }else if(val.i_id&&val.i_level==3){
                        this.addTitle='新增街道'
                    }
                }else if(type=='edit'){
                    if(val.i_id&&val.i_level==0){
                        this.addTitle='编辑国家'
                    }else if(val.i_id&&val.i_level==1){
                        this.addTitle='编辑省'
                    }else if(val.i_id&&val.i_level==2){
                        this.addTitle='编辑市'
                    }else if(val.i_id&&val.i_level==3){
                        this.addTitle='编辑区'
                    }else if(val.i_id&&val.i_level==4){
                        this.addTitle='编辑街道'
                    }
                }
                this.addProp={
                    data:val,
                    type:type
                };
                this.showMenuId=null;

            },
            closeAddFun(type='close'){
                this.dialogVisible=false
                if(type=='save'){
                    if(this.chooseNode&&this.chooseNode.i_level==3) {
                        this.getJd(this.chooseNode.i_id)
                        // this.chooseNode = null
                    }else{
                        this.refreshTree()

                    }

                }
            },
            transferFun(val,type){
                this.showMenuId=null;
                this.dialogTransferVisible=true
                let data=JSON.parse(JSON.stringify(val));
                // console.log(data,'data')
                this.transferTitle='转移'+data.vc_name
                this.transferProp=val;
            },
            closeTransferFun(type='close'){
                this.dialogTransferVisible=false
                if(type=='save'){
                    if(this.chooseNode.i_level==3) {
                        this.getJd(this.chooseNode.i_id)
                        // this.chooseNode = null
                    }else{
                        this.refreshTree()

                    }
                }
            },
            handleNodeClick(val){
                // console.log('val',val)
                this.showMenuId=null;
                let data=JSON.parse(JSON.stringify(val));
                if(val.i_level==3){
                    this.getJd(val.i_id);
                    this.chooseNode=data
                }else{
                    this.chooseNode=null
                    this.tableData=[]
                }
                // this.$emit('showData',data)
            },
            loadNode(node, resolve) {
                this.showMenuId=null;
                let _this=this;
                if (node.level === 0) {
                    let val={i_id:0,i_level:0,i_pid:0,label:'全部',vc_name:'全部',children:[],childProduct:0,isLeaf:false};
                    return resolve([val]);
                }
                if (node.level>=1&&node.data.isLeaf==false){
                    _this.getAreaTree(node.data,resolve,node.level);
                }
            },
            async getAreaTree({i_id=0,type=0},resolve,level){
                let param = {
                    i_pid:i_id,
                    isuse:this.isuse,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash=one;
                            hash.isLeaf= one.i_level<3?!one.hassub:true;
                            hash.i_level= one.i_level;
                            hash.label= one.vc_name;

                            //     {
                            //     label:one.vc_name,
                            //     i_id:one.i_id,
                            //     type:one.type,
                            //     i_level:level+1,
                            //     // i_pid:one.i_pid,
                            //     isLeaf: one.childProduct==0,
                            // };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getJd(i_id=0){
                let param = {
                    i_pid:i_id,
                    isuse:this.isuse,
                };
                let res = await API.getAreaTree(param);
                if (res.code == 1) {
                    this.tableData=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .font14{
        font-size: 14px;
    }
    .flex{
        display: flex;
    }
    .fitW{
        width: fit-content;
    }
    .ps-re{
        position: relative;

    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
    .el-tree span{
        display: inline-block;
        width: 100%;
    }
    .jian{
        background-color: #409EFF ;
    }
    .zhi{
        background-color: #ff0500;
    }
    .ziicon{
        display: inline-block;
        /*padding:3px 4px;*/
        border-radius: 4px;
        border: 1px;
        color: white;
        width: 20px !important;
        height: 19px;
        line-height: 19px;
        font-size: 12px;
        margin:0 4px;
        text-align: center;
    }
</style>